import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Typography, FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import useStyles from '../styles';
export default function ConfirmTab(_ref) {
  let _ref$tenantsList = _ref.tenantsList,
    tenantsList = _ref$tenantsList === void 0 ? undefined : _ref$tenantsList,
    _ref$buildingsList = _ref.buildingsList,
    buildingsList = _ref$buildingsList === void 0 ? undefined : _ref$buildingsList;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('post_charge_modal.you_are_about_to_post')), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, tenantsList && /*#__PURE__*/React.createElement(React.Fragment, null, tenantsList.map(tenant => /*#__PURE__*/React.createElement("div", {
    key: tenant,
    className: classes.tenant
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, tenant), /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, "$10.00")))), buildingsList && /*#__PURE__*/React.createElement(React.Fragment, null, buildingsList.map(building => /*#__PURE__*/React.createElement(React.Fragment, {
    key: building.address
  }, building.tenants.map(tenant => /*#__PURE__*/React.createElement("div", {
    key: tenant,
    className: classes.tenant
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, building.address, ": ", t('general.unit'), " ", tenant), /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, "$10.00"))))))), /*#__PURE__*/React.createElement("div", {
    className: classes.notificationCheckbox
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, null),
    label: t('post_charge_modal.send_in-app_notifications')
  }))));
}
ConfirmTab.propTypes = {
  tenantsList: PropTypes.arrayOf(PropTypes.string),
  buildingsList: PropTypes.arrayOf(PropTypes.shape({
    address: PropTypes.string,
    tenants: PropTypes.arrayOf(PropTypes.string)
  }))
};